import React from 'react';
import {
	Create,
	SimpleForm,
	ReferenceInput,
	TextInput,
	SelectInput,
	required
} from 'react-admin';
import PropTypes from 'prop-types';
import { coreWalletPaymentFailureTypesForSelection } from './PaymentFailureConstants';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// TextInput can't use some properties typically propagated down to children of <ReferenceInput>
const SanitizedTextInputForReferenceInput = ({ setFilter, setPagination, setSort, ...rest }) => <TextInput {...rest} />;

const PaymentFailureCreate = ({ paymentFailureTypesForSelection, ...props }) => {
	const location = useLocation();
	const parameters = parse(location.search);
	const payment = useSelector(state => {
		return state.admin.resources.payments && state.admin.resources.payments.data[parameters.paymentId];
	});
	const currency = payment ? payment.amount.currency : null;
	return (
		<Create {...props}>
			<SimpleForm variant="standard">
				<ReferenceInput source="paymentId" reference="payments" validate={required()}>
					<SanitizedTextInputForReferenceInput fullWidth />
				</ReferenceInput>
				<SelectInput
					source="paymentFailureType"
					choices={paymentFailureTypesForSelection}
					validate={required()}
				/>
				<TextInput source="failureAmount" validate={required()} />
				<TextInput source="failureCurrency" defaultValue={currency} disabled />
				<TextInput source="description" />
				<TextInput source="externalReferenceId" />
			</SimpleForm>
		</Create>
	);
};

PaymentFailureCreate.propTypes = {
	paymentFailureTypesForSelection: PropTypes.array.isRequired
};
PaymentFailureCreate.defaultProps = {
	paymentFailureTypesForSelection: coreWalletPaymentFailureTypesForSelection
};

export default PaymentFailureCreate;
